import { Row } from 'antd';
import { useAppSelector } from 'app/hooks';
import clsx from 'clsx';
import { selectPlantInfo } from 'features/Plant/plantSlice';
import * as React from 'react';
import { FaChartBar, FaCity, FaIndustry, FaServer, FaTemperatureLow } from 'react-icons/fa';
import style from './PlantMenu.module.scss';
import { GiSunflower } from "react-icons/gi";
export interface PlantMenuProps {
  setIsShowItem: (value: string) => void;
  isShowItem: string;
}

export default function PlantMenu({ setIsShowItem, isShowItem }: PlantMenuProps) {
  const userInfo = useAppSelector(selectPlantInfo);
  const data = [
    {
      content: 'Plant Information',
      icon: <FaCity />,
    },
    {
      content: 'Devices',
      icon: <FaIndustry />,
    },
    // {
    //   content: 'Performance',
    //   icon: <FaChartBar />,
    // },
    {
      content: 'Electricity Cost',
      icon: <FaServer />,
    },
    {
      content: 'Weather Sensor',
      icon: <FaTemperatureLow />,
    },
  ];
  return (
    <div className={style.root}>
      <div className={style.name_plant}>
        <p>{userInfo?.label}</p>
      </div>
      <div className={style.sidebar_main_management}>
        {data.map((item, index) => (
          <Row
            align={'middle'}
            key={`menuPlant_${index}`}
            onClick={() => {
              setIsShowItem(item.content);
            }}
            className={clsx(style.item_sidebar_management, {
              [style.active]: isShowItem === item.content,
            })}
          >
            <div
              style={{
                fontSize: '20px',
                marginRight: '20px',
              }}
            >
              {item.icon}
            </div>
            {item.content}
          </Row>
        ))}
      </div>
    </div>
  );
}
